import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Card,
  Container,
  Row,
  Col,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";
import { axiosOpen } from "../../api/axios";
import SearchProduct from "../SearchProduct/";
import { toast, Toaster } from "react-hot-toast";

const ProductAnalysisResult = ({
  scrapedProductData,
  handleSubmit,
  loader,
}) => {
  const [productDetails, setProductDetails] = useState();

  useEffect(() => {
    const data = {};
    data.title = scrapedProductData.title.toString() || "NA";
    data.description =
      Array.isArray(scrapedProductData.description) // Check if it's already an array
        ? scrapedProductData.description
        : scrapedProductData.description.split("\n"); // Split the string into an array

    data.gradeLevels = scrapedProductData.gradeLevels || "NA";
    data.subjects = scrapedProductData.subjects || "NA";
    data.resourceType = scrapedProductData.resourceType || "NA";
    data.formatsIncluded = scrapedProductData.formatsIncluded || "NA";
    setProductDetails(data);
  }, [scrapedProductData]);


  return (
    <>
      <Card.Header className="form-header">
        Product Page  Data
      </Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col>
              <label>
                <b>Product Title:</b>
              </label>
              <p>{productDetails?.title}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Product Description:</b>
              </label>
              <ul>{productDetails?.description}</ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Grade Levels:</b>
              </label>
              <ul>{productDetails?.gradeLevels}</ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Subjects:</b>
              </label>
              <ul>{productDetails?.subjects}</ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Resource Type:</b>
              </label>
              <ul>{productDetails?.resourceType}</ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>formats Included:</b>
              </label>
              <ul>{productDetails?.formatsIncluded}</ul>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              {loader ? (
                <Button variant="primary" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  &nbsp;Loading...
                </Button>
              ) : (
                <Button variant="primary" onClick={handleSubmit}>
                  Analyze Product <AiOutlineArrowRight />
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </>
  );
};

const ProductAnalysisForm = ({
  handleSubmit,
  loader,
  productLinkhandler,
  alternateStep,
}) => {
  const [website, setWebsite] = useState("teacherspayteachers");

  return (
    <>
      <Card.Header className="form-header">
        Scrape EduAiBoost Product Page Data
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicWebsite">
            <Form.Label className="form-label">
              Select your website
            </Form.Label>
            <Form.Select
              value={website}
              onChange={(event) => setWebsite(event.target.value)}
            >
              <option value="teacherspayteachers">Teacherspayteachers.com</option>
              <option value="teachstarter" disabled>
                https://www.teachstarter.com/
              </option>
              <option value="tes" disabled>
                https://www.tes.com/
              </option>
              <option value="teachervision" disabled>
                https://www.teachervision.com/
              </option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicProductLink">
            <Form.Label className="form-label">
              EduAiBoost Product Link
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Product Link"
              onChange={(event) => productLinkhandler(event.target.value)}
              required
            />
          </Form.Group>
          <div className="text-center">
            {loader ? (
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                &nbsp;&nbsp;Scraping...
              </Button>
            ) : (
              <Button variant="primary" type="submit" className="">
                Scrape&nbsp;
                <AiOutlineArrowRight />
              </Button>
            )}
          </div>
          <div className="text-center pt-4 d-flex justify-content-center align-items-center font-weight-bold">
            Don't have product link? No worries&nbsp;
            <Button variant="link" className="p-0" onClick={alternateStep}>
              Click Here
            </Button>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

const PromptOutput = ({ openaiProductData = {}, setStep }) => {
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState(null);
  const [deletePromptModal, setDeletePromptModal] = useState(false);
  const promptID = openaiProductData.promptid || null;

  const handleDiscardModal = () =>
    setDeletePromptModal((currentState) => !currentState);

  useEffect(() => {
    if (Object.keys(openaiProductData).length > 0) {
      const data = {};
      data.title =
        openaiProductData.title.length > 0
          ? openaiProductData.title.trim()
          : "NA";
      data.description =
        openaiProductData.description.length > 0
          ? openaiProductData.description.trim()
          : "NA";
      data.features =
        openaiProductData.features.length > 0
          ? openaiProductData.features
            .replace("\n\n-", "")
            .replace("\n\n", "")
            .replace(/\n\n/g, "<br/>")
            .replace(/\n•/g, "<br/>")
            .replace("1. ", "")
            .replace(/\n[0-9]./g, "<br/>")
            .replace(/\n-/g, "<br/>")
            .split("<br/>")
          : "NA";
      data.features = data.features.map((list, index) => (
        <li key={index}>{list}</li>
      ));
      setProductDetails(data);
    }
  }, []);

  const handleDiscard = () => {
    (async () => {
      const response = await axiosOpen.delete(
        `prompt/deleteprompt/${promptID}`
      );
      setStep(1);
      // navigate("/analysed-products", { replace: true });
    })();
  };

  return (
    <>
      <Card.Header className="form-header">Data Optimized</Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col>
              <label>
                <b>Product Title:</b>
              </label>
              <p>{productDetails?.title}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Product Description:</b>
              </label>
              <p className="line-break">{productDetails?.description.trim()}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Product Features:</b>
              </label>
              <ul>{productDetails?.features}</ul>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <Button
                variant="secondary"
                onClick={() => setDeletePromptModal(true)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Container>
      </Card.Body>
      <Modal show={deletePromptModal} onHide={handleDiscardModal}>
        <Modal.Header closeButton>
          <Modal.Title className="font-size-primary">
            Are you sure you want to discard the prompt ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="font-size-secondary">
          The prompt will be deleted immediately. You can't undo this action
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="font-size-secondary"
            variant="secondary"
            onClick={handleDiscardModal}
          >
            Cancel
          </Button>
          <Button
            className="font-size-secondary"
            variant="primary"
            onClick={handleDiscard}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const AnalyzeProduct = () => {
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(false);
  const [productLink, setProductLink] = useState("");
  const [scrapedProductData, setScrapedProductData] = useState(null);
  const [openaiProductData, setOpenaiProductData] = useState({});
  const userID = JSON.parse(localStorage.getItem("userID"));
  const navigate = useNavigate();

  const handleLoader = () => setLoader((currentValue) => !currentValue);

  const handleFirstStep = (e) => {
    if (!productLink) return false;
    e.preventDefault();
    handleLoader();
    (async () => {
      try {
        const scrapedResponse = await axiosOpen.post(`scrape/pdp/`, {
          product_url: productLink.toString(),
        });
        setScrapedProductData(scrapedResponse.data);
        handleLoader();
        setStep(2);
      } catch (err) {
        handleLoader();
        toast.error(
          err?.response?.data?.message || "Oops, Something went wrong"
        );
        if (err.response.status === 401) {
          setTimeout(() => {
            navigate("/subscription-plans", { replace: true });
          }, 5000);
        }
      }
    })();
  };

  const handleStepTwo = (e) => {
    if (e) {
      e.preventDefault();
    }
    setStep(3);
  };

  const handleStepThree = (e, formData) => {
    e.preventDefault();
    if (
      formData.title === "" ||
      formData.description === "" ||
      formData.gradeLevels === "" ||
      formData.subjects === "" ||
      formData.resourceType === "" ||
      formData.formatsIncluded === ""
    ) {
      return false;
    }
    handleLoader();
    (async () => {
      try {
        const response = await axiosOpen.post(
          `amazon/getAnalyzedData/${userID}`,
          {
            ...formData,
            platform: 'TPT'
          }
        );
        setOpenaiProductData(response.data);
        handleLoader();
        setStep(4);
        toast.success("Your data has been optimized and saved automatically");
      } catch (err) {
        console.log(err);
        toast.error("Oops, Something went wrong");
        handleLoader();
      }
    })();
  };

  async function handleAlternateStep() {
    // const { data } = await axiosOpen.get(`subscriber/get/${userID}`);
    // if (data) {
    handleStepTwo();
    // } else {
    //   toast.error("Please subscribe to a plan to continue");
    // }
  }

  return (
    <div className="analyze-product-page">
      <Toaster position="top-right" reverseOrder={false} />
      <Container>
        <Row>
          <Col>
            <Card>
              {step === 1 && (
                <ProductAnalysisForm
                  handleSubmit={handleFirstStep}
                  loader={loader}
                  productLink={productLink}
                  productLinkhandler={setProductLink}
                  alternateStep={handleAlternateStep}
                />
              )}
              {step === 2 && (
                <ProductAnalysisResult
                  handleSubmit={handleStepTwo}
                  scrapedProductData={scrapedProductData}
                  loader={loader}
                />
              )}
              {step === 3 && (
                <SearchProduct
                  handleSubmit={handleStepThree}
                  scrapedProductData={scrapedProductData}
                  loader={loader}
                  setStep={setStep}
                />
              )}
              {step === 4 && (
                <PromptOutput openaiProductData={openaiProductData}
                  setStep={setStep}
                />
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AnalyzeProduct;
